<docs>
# Scroll Transition

> NOTE: this docs defined at **docs** section inside ScrollTrans.vue module

<!-- STORY -->

### Example

>Type

```html
<div class="section scroll-transition">
  <div class="inner">
    <div id="scroll1">
      <mt-scroll-trans wrapper=".scroll-transition" scrollEle="scroll1">Direction default(top)</mt-scroll-trans>
    </div>
    <div id="scroll2">
      <mt-scroll-trans wrapper=".scroll-transition" scrollEle="scroll2" direction="bottom">Direction bottom</mt-scroll-trans>
    </div>
    <div id="scroll3">
      <mt-scroll-trans wrapper=".scroll-transition" scrollEle="scroll3" direction="left">Direction left</mt-scroll-trans>
    </div>
    <div id="scroll4">
      <mt-scroll-trans wrapper=".scroll-transition" scrollEle="scroll4" direction="right">Direction right</mt-scroll-trans>
    </div>
  </div>
</div>
```

```scss
.scroll-transition {
  height: 300px;
  overflow: scroll;
  font-size: 3em;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(31, 45, 61, 0.14);
    outline: 1px solid rgba(31, 45, 61, 0.14);
    border-radius: 4px;
  }
  .inner {
    height: 1500px;
    &>div {
      height: 300px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  #scroll1 {
    background-color: #50C3F7;
  }
  #scroll2 {
    background-color: #7986CB;
  }
  #scroll3 {
    background-color: #AED581;
  }
  #scroll4 {
    background-color: #BA68C8;
  }
}
```

#### Props

| Property  | Description               | Type     | Accepted Values       | Default |
|-----------|---------------------------|----------|-----------------------|---------|
| direction | transition direction from | String   | top/right/left/bottom | top     |
| wrapper   | wrapper is wrap scrolled box | String | only id '#wrapper' | window     |
| scrollEle | target of scrolling | String | only id | me     |
| distance | distance of trasition | String | long/normal/short | 50%     |

</docs>
<template>
  <div :id="randomId" class="mt-scroll-transition" :class="`mt-scroll-transition--${direction}-${distance}__${status}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'mt-scroll-trans',
  props: {
    direction: {
      type: String,
      default: 'top'
    },
    wrapper: {
      type: [String, Boolean],
      default: false
    },
    scrollEle: {
      type: [String, Boolean],
      default: false,
    },
    distance: {
      type: String,
      default: 'normal',
    }
  },
  components: {

  },
  data () {
    return {
      randomId: '',
      status: 'off',
      wrapperObj: null
    }
  },
  computed: {

  },

  methods: {
    randomString() {
      let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let string_length = 15;
      let randomstring = '';
      for (let i=0; i<string_length; i++) {
        let rnum = Math.floor(Math.random() * chars.length);
        randomstring += chars.substring(rnum,rnum+1);
      }
      return randomstring;
    },

    isInViewport(elem){
      let bounding = elem.getBoundingClientRect();
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        (bounding.top + 100) <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },

  created(){
    this.randomId = this.randomString()
  },

  mounted(){
    let that = this
    this.$nextTick(function () {
      setTimeout(function () {
        let target = document.getElementById(that.randomId)
        if(that.scrollEle){
          target = document.getElementById(that.scrollEle)
        }
        if(!that.wrapper){
          that.wrapperObj = window
        }else{
          that.wrapperObj = document.querySelector(that.wrapper)
        }
        that.wrapperObj.addEventListener('scroll', function (event) {
          if (that.isInViewport(target)) {
            that.status = 'on'
          }
        }, false);
      })
    })



  },

  destroyed() {
    this.wrapperObj.removeEventListener('scroll', this.onScroll)
  }


}
</script>

<style src="./ScrollTrans.scss" lang="scss">

</style>



// WEBPACK FOOTER //
// ScrollTrans.vue?c95676bc